
import * as THREE from 'three';
import { Point } from '../graphicLibs/index';
import { PointInfo } from '../WalltoFittingInfo';

type listType = {data: number, index: N};
type N = number | number[];
type gridNumber = {x: number, y: number}

export class WallGrid {
    
    // しきい値
    public e = 0.05;
    protected column: number;
    protected row: number;
    protected indexToGridList: number[] = [];
    protected maxZ = {index: 0, z: 0};
    public clockwiseData: number[][];

    constructor(public pointList: PointInfo[]) {
        // スイープ&プルーン grid作成
        let XList: listType[] = [];
        let ZList: listType[] = [];
        // x,z 方向 それぞれのindex配列を作成する
        for (let i = 0; i < this.pointList.length; i++) {
            XList.push({data: this.pointList[i].point.x, index: i});
            ZList.push({data: this.pointList[i].point.z, index: i});
        }
        XList.sort((list1, list2) => list1.data - list2.data);
        ZList.sort((list1, list2) => list1.data - list2.data);

        const X = this.NeighborhoodPointSearch(XList);
        this.row =  X.length;
        const Z = this.NeighborhoodPointSearch(ZList);

        // xzに対してのgridListを作成
        const gridList = this.createGrid(X, Z);
        // console.log(JSON.parse(JSON.stringify(gridList)));

        // z方向から時計周りのindexデータに変換する
        this.clockwiseData = this.clockwise(gridList);
        // console.log(JSON.parse(JSON.stringify(this.clockwiseData)));
    }
    
    // xzに対してのgridListを作成
    private createGrid(XList: listType[], ZList: listType[]): number[][] {

        const reserch = (list: listType[], num: number): number => {
            return list.findIndex((value: listType) => {
                const indexList = (!Array.isArray(value.index)) ? [value.index] : value.index;
                const i = indexList.findIndex((index: number) => num == index);
                return (i != -1);
            });
        }

        const gridList = new Array(XList.length * ZList.length);
        for (let i = 0; i < this.pointList.length; i++) {
            const x = reserch(XList, i);
            const z = reserch(ZList, i);
            const index = Point.indexFromGridNumber(x, z, this.row);
            if (gridList[index] == null) gridList[index] = [];
            gridList[index].push(i);
            this.indexToGridList.push(index);
            if (this.maxZ.z < z) this.maxZ = {index: index, z: z};
        }

        return gridList;
    }
    
    // z方向から時計周りのindexデータに変換する
    private clockwise(list: number[][]): number[][] {
        const worldZ = new THREE.Vector3(0, 0, 1);
        for (let i = 0; i < list.length; i++) {
            // 末端の場合はreturn
            if (!Array.isArray(list[i])) continue;

            const indexList = [];
            for (let j = 0; j < list[i].length; j++) {
                const point = this.pointList[list[i][j]].point.clone();
                // let nextIndex = (list[i][j] % 2 == 0) ? list[i][j] + 1 : list[i][j] - 1;
                const vec3 = this.pointList[Point.nextPoint(list[i][j])].point.clone();
                const dir = vec3.clone().sub(point);
                // テスト表示
                // this.draw(dir.normalize(), point);
                let rad = dir.clone().normalize().angleTo(worldZ);
                // radiunを 0 < rad < 2π に直す
                if (dir.clone().cross(worldZ).y < 0) {
                    rad = 2 * Math.PI - rad;
                }

                indexList.push({index: list[i][j], rad: rad});
                if (j != 0) indexList.sort((a,b) => a.rad < b.rad ? -1 : 1);
            }
            list[i] = indexList.map((value) => value.index);
        }

        return list;
    }
    
    // 近傍点探索リスト
    private NeighborhoodPointSearch(list: listType[]): listType[] {
        const result: listType[] = []
        const averageData: listType[] = [];
        for (let i = 0; i < list.length; i++) {
            result.push(list[i]);
            // e以上なら近傍点探索を打ち切る 配列の最後を考慮( % list.length )
            if (Math.abs(list[i].data - list[(i + 1) % list.length].data) > this.e) {
                // 近傍点が存在するときはその平均値に集約させる
                const ave = this.average(result);
                averageData.push(ave);
                result.length = 0;
            }
        }

        return averageData;
    }

    // 平均値リストを返す
    private average(list: listType[]): listType {
        if (list.length == 1) return list[0];
        let sum = 0;
        const indexList = [];
        for (let i = 0; i < list.length; i++) {
            sum += list[i].data;
            indexList.push(list[i].index);
        }

        return {data: sum / list.length, index: indexList};
    }
    
}